import { useMutation } from '@tanstack/react-query';
import { uploadOrderSignature } from '../services';

const useUploadOrderSignature = () => {
  return useMutation({
    mutationKey: ['uploadOrderSignature'],
    mutationFn: async (payload) => await uploadOrderSignature(payload),
    retry: 3,
  });
};

export default useUploadOrderSignature;
